import React from 'react'
import { connect } from 'react-redux'
import Pagination from 'react-js-pagination'
import moment from 'moment'
import FormatMoney from '../../Utils/FormatMoney'
import OrderActions from '../../Redux/OrderRedux'
import Modal from 'react-responsive-modal'

class ChatbotList extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.state = {
      tab: 'wifi-rental',
      modal: null,
      detail: {},
      filter: {
        type: 'wifi-rental',
        page: 1,
        limit: 10,
        status: 'incoming-order'
      }
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _fetchData = (filter = { page: 1 }, event) => {
    if (event) event.preventDefault()
    let params = {
      ...this.state.filter,
      ...filter
    }
    this.props.get(params)
  }

  _filterChange = (data, field) => {
    let filter = { ...this.state.filter }
    filter[field] = data.target.value
    this.setState({ filter })
  }

  _changeTab = (tab) => {
    let filter = { ...this.state.filter }
    filter.page = 1
    filter.type = tab
    this.setState({ filter, tab })
    setTimeout(() => {
      this._fetchData()
    }, 250)
  }

  _toggleModal = (modal = null) => {
    if (!modal) { this._fetchData() }
    this.setState({ modal })
  }

  _selectItem = (item, modal) => {
    this.setState({ detail: item })
    this._toggleModal(modal)
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter, page }
    this.setState({ filter })
    this._fetchData({ page })
  }

  _confirm = (uuid) => {
    let form = { type: this.state.tab }
    let data = { uuid, form }
    this.props.post(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _renderTable = (data, tab) => {
    switch (tab) {
      case 'wifi-rental':
        return (
          <table className='table table-hover table-striped'>
            <thead>
              <tr>
                <th className='text-center'>Customer</th>
                <th className='text-center'>Email</th>
                <th className='text-center'>Phone</th>
                <th className='text-center'>Account Number</th>
                <th className='text-center'>Account Name</th>
                <th className='text-center'>Bank Name</th>
                <th className='text-center'>Bank Branch</th>
                <th className='text-center'>Product</th>
                <th className='text-center'>Country</th>
                <th className='text-center' style={{ minWidth: '250px' }}>Start - End Date</th>
                <th className='text-center'>Total Qty</th>
                <th className='text-center'>Unique Number</th>
                <th className='text-center'>Total Admin Fee</th>
                <th className='text-center'>Total Deposit Amount</th>
                <th className='text-center'>Total Amount</th>
                <th className='text-center'>Final Amount</th>
                <th className='text-center'>Receive Method</th>
                <th className='text-center'>Return Method</th>
                <th className='text-center'>Receive Courier Address</th>
                <th className='text-center'>Receive Airport Terminal</th>
                <th className='text-center'>Receive Airport Estimate Time</th>
                <th className='text-center'>Receive Airport Date</th>
                <th className='text-center'>Confirm Order</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-center'>{item.customer_name || '-'}</td>
                    <td className='text-center'>{item.email || '-'}</td>
                    <td className='text-center'>{item.phone || '-'}</td>
                    <td className='text-center'>{item.account_number || '-'}</td>
                    <td className='text-center'>{item.account_name || '-'}</td>
                    <td className='text-center'>{item.bank_name || '-'}</td>
                    <td className='text-center'>{item.bank_branch || '-'}</td>
                    <td className='text-center'>{item.product_name || '-'}</td>
                    <td className='text-center'>{item.country || '-'}</td>
                    <td className='text-center'>
                      { item.start_date ? moment(item.start_date).format(this.dateFormat) : '-'} - {item.start_date ? moment(item.end_date).format(this.dateFormat) : '-' }
                    </td>
                    <td className='text-center'>{item.total_qty || '-'}</td>
                    <td className='text-center'>{item.unique_number || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.total_admin_fee) || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.total_deposit_amount) || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.total_amount) || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.final_amount) || '-'}</td>
                    <td className='text-center'>{item.receive_method || '-'}</td>
                    <td className='text-center'>{item.return_method || '-'}</td>
                    <td className='text-center'>{item.receive_courier_address || '-'}</td>
                    <td className='text-center'>{item.receive_airport_terminal || '-'}</td>
                    <td className='text-center'>{item.receive_airport_estimate_time || '-'}</td>
                    <td className='text-center'>
                      { item.receive_airport_date ? moment(item.receive_airport_date).format(this.dateFormat) : '-' }
                    </td>
                    <td className='text-center'>
                      {
                        item.current_step === 'incoming-order'
                          ? <button className='btn btn-primary' onClick={() => this._selectItem(item, 'confirm')}>
                            <i className='fa fa-check-square' /> Confirm
                          </button>
                          : '-'
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      case 'wifi-extend':
      case 'add-quota':
        return (
          <table className='table table-striped table-hover'>
            <thead>
              <tr>
                <th className='text-center'>Order Number</th>
                <th className='text-center'>Modem Series</th>
                <th className='text-center'>Quota</th>
                <th className='text-center'>Product Name</th>
                <th className='text-center'>Country</th>
                <th className='text-center' style={{ minWidth: '250px' }}>Start Date - End Date</th>
                <th className='text-center'>Unique Number</th>
                <th className='text-center'>Total Admin Fee</th>
                <th className='text-center'>Total Amount</th>
                <th className='text-center'>Final Amount</th>
                <th className='text-center'>Confirm Order</th>
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, i) => (
                  <tr key={i}>
                    <td className='text-center'>{item.order_number || '-'}</td>
                    <td className='text-center'>{item.modem_series || '-'}</td>
                    <td className='text-center'>{item.quota || '-'}</td>
                    <td className='text-center'>{item.product_name || '-'}</td>
                    <td className='text-center'>{item.country || '-'}</td>
                    <td className='text-center'>
                      { item.start_date ? moment(item.start_date).format(this.dateFormat) : '-'} - {item.start_date ? moment(item.end_date).format(this.dateFormat) : '-' }
                    </td>
                    <td className='text-center'>{item.unique_number || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.total_admin_fee) || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.total_amount) || '-'}</td>
                    <td className='text-center'>{FormatMoney(item.final_amount) || '-'}</td>
                    <td className='text-center'>
                      {
                        item.current_step === 'incoming-order'
                          ? <button className='btn btn-primary' onClick={() => this._selectItem(item, 'confirm')}>
                            <i className='fa fa-check-square' /> Confirm
                          </button>
                          : '-'
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      default:
        return null
    }
  }

  render () {
    const { order } = this.props
    return (
      <section className='section'>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Chatbot Order List
              {
                (order.fetching || order.processing) &&
                <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            <div className='btn-group' role='group'>
              <button className={`btn btn-primary ${this.state.tab === 'wifi-rental' && 'active'}`} onClick={() => this._changeTab('wifi-rental')}>Wifi Rental</button>
              <button className={`btn btn-primary ${this.state.tab === 'wifi-extend' && 'active'}`} onClick={() => this._changeTab('wifi-extend')}>Wifi Extend</button>
              <button className={`btn btn-primary ${this.state.tab === 'add-quota' && 'active'}`} onClick={() => this._changeTab('add-quota')}>Add Quota</button>
            </div>
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <form className='form-inline' onSubmit={(event) => this._fetchData({ page: 1 }, event)}>
              <div className='form-group mr-2'>
                <label className='control-label mr-2'>Status</label>
                <select className='form-control mr-2' onChange={(event) => this._filterChange(event, 'status')}>
                  <option value='incoming-order'>Incoming Order</option>
                  <option value='processed'>Processed</option>
                </select>
              </div>
              <div className='form-group mr-2'>
                <button type='submit' className='btn btn-primary'>Apply Filter</button>
              </div>
            </form>
          </div>
        </header>
        <div className='card'>
          <div className='card-block'>
            {
              (!order.DATA_CHATBOT || order.DATA_CHATBOT.data.length === 0)
                ? <div>
                  <h4 className='title text-center align-middle'>
                    { !(order.fetching || order.processing) && '-- No Data --' }
                  </h4>
                </div>
                : this._renderTable(order.DATA_CHATBOT.data, this.state.tab)
            }
          </div>
        </div>
        <Modal center open={this.state.modal === 'confirm'} onClose={this._toggleModal}>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h4 className='title mr-auto'>Confirm Order</h4>
            </div>
            <div className='section text-center'>
              <div>
                {
                  this.state.tab === 'wifi-rental'
                    ? <span>
                      <h5 className='center'><strong>Customer name:</strong> {this.state.detail.customer_name}</h5>
                      <h5 className='center'><strong>Product name:</strong> {this.state.detail.product_name}</h5>
                    </span>
                    : <span>
                      <h5 className='center'><strong>Order number:</strong> {this.state.detail.order_number}</h5>
                      <h5 className='center'><strong>Modem series:</strong> {this.state.detail.modem_series}</h5>
                    </span>
                }
              </div>
            </div>
            <div className='form-group d-flex justify-content-end'>
              <button onClick={() => this._toggleModal()} className='btn btn-secondary mr-2'>Cancel</button>
              <button onClick={() => this._confirm(this.state.detail.id)} className='btn btn-primary'>Confirm</button>
            </div>
          </section>
        </Modal>
        <section className='section text-center'>
          {
            (order.DATA_CHATBOT && order.DATA_CHATBOT.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={order.DATA_CHATBOT.page || this.state.filter.page}
              itemsCountPerPage={10}
              totalItemsCount={order.DATA_CHATBOT.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  get: (filter) => dispatch(OrderActions.getChatbotOrderRequest(filter)),
  post: (data) => dispatch(OrderActions.postChatbotOrderRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ChatbotList)



// WEBPACK FOOTER //
// ./src/Pages/Order/ChatbotList.js